import { render, staticRenderFns } from "./stockout_view.vue?vue&type=template&id=4c633379&scoped=true&"
import script from "./stockout_view.vue?vue&type=script&lang=js&"
export * from "./stockout_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c633379",
  null
  
)

export default component.exports